import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { TicketCompletionCode } from "@app/models/rest/ticket-completion-code";

@Injectable({
  providedIn: "root"
})
export class TicketCompletionCodeRestService extends HateoasResourceOperation<TicketCompletionCode> {
  constructor() {
    super(TicketCompletionCode);
  }
}
